export interface FormsAutocompleteGlobalMappingFinishedActionType {
  type: '@forms/AUTOCOMPLETE_GLOBAL_MAPPING_FINISHED';
}

export const autocompleteGlobalMappingFinished = (): FormsAutocompleteGlobalMappingFinishedActionType => ({
  type: '@forms/AUTOCOMPLETE_GLOBAL_MAPPING_FINISHED',
});
